<template>
  <div class="box" :class="[{ fill: fill }]">
    <slot></slot>
  </div>
</template>
<script>
export default {
  //只是一个盒子
  name: 'box',
  props: {
    fill: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  data() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
.box {
  display: flex;
  text-align: left;
  flex-direction: column;
  background: #ffffff;
  padding: 10px 20px;
  margin: 8px 5px;
  box-shadow: 0px 3px 6px rgba(175, 175, 175, 0.2);
  border-radius: 6px;
}
.box.fill {
  //height: 0;
  flex: 1;
}
</style>
